import { connect } from 'react-redux';
import {
  fetchActionRequiredCount,
} from 'common/message-center/containers/message-center-actions';
import { clearNavigationalInfo } from 'common/navigation/containers/navigation-actions';
import { clearReferenceData } from 'common/reference-data/containers/reference-data-actions';
import { fetchUser } from 'common/user/containers/user-actions';
import ServiceCenterToggle from '../components/service-center-toggle';
import { setActiveServiceCenter, getIsDecimal } from './service-center-toggle-actions';

const mapStateToPprops = state => ({
  serviceCenters: state.user.serviceCenters,
  adminFor: state.user.adminFor,
  currentServiceCenter: state.serviceCenter.activeServiceCenter,
  isDecimal: state.serviceCenter.isDecimal,
});

const mapDispatchToProps = {
  fetchActionRequiredCount,
  clearNavigationalInfo,
  clearReferenceData,
  setActiveServiceCenter,
  fetchUser,
  getIsDecimal,
};

export default connect(mapStateToPprops, mapDispatchToProps)(ServiceCenterToggle);
